// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  API_Link: 'http://localhost:3000',
  firebase : {
    apiKey: "AIzaSyAIj3KBVRimY-gmftyBn32_-BL9d_dNQks",
    authDomain: "catutors-824b4.firebaseapp.com",
    projectId: "catutors-824b4",
    storageBucket: "catutors-824b4.appspot.com",
    messagingSenderId: "917568348272",
    appId: "1:917568348272:web:957ac83b7a2960c15b14b5",
    measurementId: "G-LBQ1SSJHGY"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
